import { useDataViewChartView } from '@aibees/elephant/context/data-view-context';
import { CrawlRequestErrorProvider } from '@aibees/elephant/feature/suggestion-search-bar/components/crawl-request/crawl-request-error-context';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { DynamicSearchBar } from '../dynamic-search-bar';
import { EntitySearchHeader } from '../entity-search-header';
import { StatisticsCardWrapper } from '../statistics-card-wrapper';
import * as Styled from './styles';
import type { SearchBarProps as Props } from './types';

export const SearchBar = memo(({ className, compact }: Props) => {
  const { isChartView } = useDataViewChartView();

  if (isChartView) return null;

  return (
    <Styled.Wrapper className={classnames('SearchBar', className, { compact })}>
      {!compact && <EntitySearchHeader />}
      <CrawlRequestErrorProvider>
        <DynamicSearchBar compact={compact} />
      </CrawlRequestErrorProvider>
      {!compact && <StatisticsCardWrapper />}
    </Styled.Wrapper>
  );
});
